import React from 'react';
import Hdr from '../shared/Hdr';
import { Link } from 'react-router-dom';

import { useState, useEffect } from 'react';
import swal from 'sweetalert';

import { apiPath1 } from "../services/apiConfig";
import TopBanner from '../components/TopBanner';

import { motion, AnimatePresence } from "framer-motion";

function Users() {
  const user = localStorage.getItem('user-info');
  const token = localStorage.getItem('token');
  const usrRole = localStorage.getItem('user-role');
  const usrName = localStorage.getItem('userName');
  const [displayUser, setDisplayuser] = useState(false);
  const [displayStore, setDisplayStore] = useState('none');
 // const [displayDept, setDisplayDept] = useState(false);
  const [displayRole, setDisplayRole] = useState(false);
  const [displayUpdUser, setDisplayUpdUser] = useState(false);
  const [data, setData] = useState([]);
  const [dataStat, setDataStat] = useState();
  const [userName, setUserName] = useState('');
  //const [uid, setUID]=useState('')
  const [address, setAddress] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [uid, setUID] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [role, setRole] = useState('admin');
  const [verfied, setVerfied] = useState(false);
  const [updUserName, setUserUpdName] = useState('');
  //  const [updAddress, setUpdAddress] = useState('');
  //  const [updPhoneNumber, setPhoneUpdNumber] = useState('');
  const [userId, setUserID] = useState('');
  const [uidErr, setUIDErr] = useState('');
  const [pwdErr, setPwdErr] = useState('');
  const [email, setEmail] = useState('')

  const [roledata, setRoleData] = useState([])
  const [roleStatus, setRoleStat] = useState()
  const [storedata, setStores] = useState([])
  const [store, setStore] = useState('')
  const [deptdata, setDeptData] = useState([])
  const [department, setDept] = useState('')

  const [updLoginId, setUpdLoginId] = useState()
  const [updMobile, setUpdMobile] = useState()
  const [updEmail, setUpdEmail] = useState()
  const [updRole, setUpdRole] = useState()
  const [updStoreId, setupdStoreId] = useState('')

  const [adm, setAdm] = useState(false)

  const [selectedUID, setSelectedUID] = useState('')
  const [selectedName, setSelectedName] = useState('')
  const [selectedPhone, setSelectedPhone] = useState('')
  const [selectedEmail, setSelectedEmail] = useState('')
  const [selectedPassword, setSelectedPassword] = useState('')
  const [selectedConfPassword, setSelectedConfPassword] = useState('')
  const [selectedRole, setSelectedRole] = useState('0')
  const [selectedStore, setSelectedStore] = useState('0')
  const [selectedDept, setSelectedDept] = useState('0')

  useEffect(() => {
    if (usrRole === 'Administrator') {
      setAdm(true)
    }
    getRoles()
    getUser()
    getStores()
    getDepts()
  }, [])

  
  const containerVariants = {
    hidden: { x: "100vw" }, // Start off-screen to the right
    visible: { x: 0 },   // Slide into view
    exit: { x: "100vw" },  // Slide off-screen to the right when exiting
  };

  const transitionSettings = {
    duration: 0.5,
    type: "tween",
    ease: "easeInOut",
  };

  function openUser() {
   // setIsOpen(true)
    setDisplayuser(true)
  }

  function openRoleUser() {
    setDisplayRole(true)
  }

  function closeRoleUser() {
    setDisplayRole(false)
  }


  function closeUser() {
    clearTransaction()
  //  setIsOpen(false)
    setDisplayuser(false)
  }

  function openUpdUser() {
    setDisplayUpdUser(true)
  }

  function closeUpdUser() {
    setDisplayUpdUser(false)
  }


  function uidHandler(e) {
    e.preventDefault()
    setSelectedUID(e.target.value)
    setUID(e.target.value)
  }

  function nameHandler(e) {
    e.preventDefault()
    setSelectedName(e.target.value)
    setUserName(e.target.value)
  }

  function phoneHandler(e) {
    e.preventDefault()
    setSelectedPhone(e.target.value)
    setPhoneNumber(e.target.value)
  }

  function emailHandler(e) {
    e.preventDefault()
    setSelectedEmail(e.target.value)
    setEmail(e.target.value)
  }

  function passwordHandler(e) {
    e.preventDefault()
    setSelectedPassword(e.target.value)
    setPassword(e.target.value)
  }

  function passwordConfHandler(e) {
    e.preventDefault()
    setSelectedConfPassword(e.target.value)
    setConfirmPassword(e.target.value)
  }

  /*RESET PASSWORD OF EXISTING USER*/
  async function ResetPw(id) {

    let result = await fetch(apiPath1 + "resetPassword/" + id, {
      method: 'PATCH',
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "Authorization": `Bearer ${token}`
      },
    });
    result = await result.json();
    showSwal(result.status, result.msg)

  }

  async function updateUser(id) {

    // alert(id+', '+updUserName+updMobile+updEmail+', '+updStoreId)
    if (updRole === "Site Engineer" || updRole === 'Store Incharge') {
      let result = await fetch(apiPath1 + "updateUser", {
        method: 'PATCH',
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "Authorization": `Bearer ${token}`
        },
        body: JSON.stringify({
          "id": id,
          "name": updUserName,
          "mobile": updMobile,
          "email": updEmail,
          "store_id": updStoreId
        })
      });
      result = await result.json();
      showSwal(result.status, result.msg)
    } else {
      let result = await fetch(apiPath1 + "updateUser", {
        method: 'PATCH',
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "Authorization": `Bearer ${token}`
        },
        body: JSON.stringify({
          "id": id,
          "name": updUserName,
          "mobile": updMobile,
          "email": updEmail
        })
      });
      result = await result.json();
      showSwal(result.status, result.msg)
    }

    getUser()

  }

  async function deleteUser(id) {
    let result = await fetch(apiPath1 + "deleteUser/" + id, {
      method: 'DELETE',
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "Authorization": `Bearer ${token}`
      },
    });

    result = await result.json();
    showSwal(result.status, result.msg)

    getUser()
  }

  async function updateOperation(id) {

   // alert('Update'+id)

    let result = await fetch(apiPath1 + "user/" + id,
      {
        method: 'GET',
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "Authorization": `Bearer ${token}`
        },
      });

    result = await result.json();

    setUserUpdName(result.data[0].name);
    setUpdLoginId(result.data[0].login_id)
    setUpdEmail(result.data[0].email)
    setUpdMobile(result.data[0].mobile)
    setUpdRole(result.data[0].role)


    if (result.data[0].role === "Site Engineer" || result.data[0].role === 'Store Incharge') {
      setupdStoreId(result.data[0].store_id)
      setDisplayStore('block')
    }
    else {
      setupdStoreId('')
      setDisplayStore('none')
    }

    setUserID(id);

    openUpdUser();
  }


  function deleteOperation(id) {

    swal({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this data!",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    })
      .then((willDelete) => {
        if (willDelete) { deleteUser(id) }
        else {
          swal("Your record is safe!");
        }

      });
  }

  function resetPasswordOperation(id) {

    swal({
      title: "Are you sure?",
      text: "on reset is will erase your old password!",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    })
      .then((willDelete) => {
        if (willDelete) { ResetPw(id) }
        else {
          swal("Your record is safe!");
        }

      });
  }


  /* LIST OF ALL USER (for initial screen)*/

  async function getUser() {

    let result = await fetch(apiPath1 + "users",
      {
        method: 'GET',
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "Authorization": `Bearer ${token}`
        },
      });

    result = await result.json();
    setDataStat(result.status);
    setData(result.data);

    if (result.status === false) {
      showSwal(result.status, result.msg)
      setData([])
    }
  }


  /* LIST OF ALL ROLE (for initial screen)*/
  async function getRoles() {
    let result = await fetch(apiPath1 + "Roles",
      {
        method: 'GET',
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "Authorization": `Bearer ${token}`
        },
      });

    result = await result.json();
    setRoleStat(result.status);
    setRoleData(result.data);

    if (result.status === false) { setRoleData([]) }
  }

  function verifyUser() {
    setPwdErr('');
    if (password !== confirmPassword) {
      setPwdErr('Both Password not same');
      return
    }
    else {
      setVerfied(true)
      addUser()
    }
  }

  /*ADD A NEW USER*/
  async function addUser() {
    if (verfied) {
      // alert(uid+', '+userName+', '+email+', '+phoneNumber+', '+password+', '+store+','+role)
      let result = await fetch(apiPath1 + "register", {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "Authorization": `Bearer ${token}`
        },
        body: JSON.stringify({
          "name": userName,
          "login_id": uid,
          "email": email,
          "mobile": phoneNumber,
          "password": password,
          "role": role,
          "store_id": store,
          "dept_id": department
        })
      });

      result = await result.json();
      showSwal(result.status, result.msg)

      getUser()
    }
  }

  function roleHandler(e) {

   // alert('role Handler' + e.target.selectedOptions[0].text)
    e.preventDefault()
    setSelectedRole(e.target.value)
    setRole(e.target.value)
    setDisplayStore('block')

    if (e.target.selectedOptions[0].text === 'Site Engineer' || e.target.selectedOptions[0].text === 'Store Incharge') {
      setDisplayStore('block')
    } else {
      setDisplayStore('none')
    }
  }

  function storeHandler(e) {
    e.preventDefault()
    setSelectedStore(e.target.value)
    setStore(e.target.value)
  }

  function deptHandler(e) {
    e.preventDefault()
    setSelectedDept(e.target.value)
    setDept(e.target.value)
  }

  /* LIST OF ALL STORES */
  async function getStores() {

    let result = await fetch(apiPath1 + "Stores",
      {
        method: 'GET',
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "Authorization": `Bearer ${token}`
        },
      });
    result = await result.json();

    if (result.status === true) { setStores(result.data) }
    else { setStores([]) }
  }

  /* LIST OF ALL DEPTS */
  async function getDepts() {

    let result = await fetch(apiPath1 + "Departments",
      {
        method: 'GET',
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "Authorization": `Bearer ${token}`
        },
      });
    result = await result.json();

    if (result.status === true) { setDeptData(result.data) }
    else { setDeptData([]) }
  }

  const [updRoleId, setUpdRoleId] = useState()

  async function changeRole(id) {
    let result = await fetch(apiPath1 + "user/" + id,
      {
        method: 'GET',
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "Authorization": `Bearer ${token}`
        },
      });

    result = await result.json();

    setUserUpdName(result.data[0].name);
    // setUpdLoginId(result.data[0].login_id)
    // setUpdEmail(result.data[0].email)
    // setUpdMobile(result.data[0].mobile)
    setUpdRoleId(result.data[0].role_id)

    setUserID(id);

    openRoleUser();
  }

  async function updateRole(id) {

    // alert(id+', '+updRoleId)
    let result = await fetch(apiPath1 + "ChangeRole", {
      method: 'POST',
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "Authorization": `Bearer ${token}`
      },
      body: JSON.stringify({
        "user_id": id,
        "new_role_id": updRoleId
      })
    });

    result = await result.json();
//console.log('Log',result)


  //  alert(result.status)
    showSwal(result.status, result.msg)
  }

  function clearTransaction() {
    setSelectedUID('')
    setSelectedName('')
    setSelectedPhone('')
    setSelectedEmail('')
    setSelectedPassword('')
    setSelectedConfPassword('')
    setSelectedRole('0')
    setSelectedStore('0')
    setSelectedDept('0')
  }

  function showSwal(stat, txt) {
    if (stat === true) {
      swal({
        title: "Success !",
        text: txt,
        icon: "success",
        button: "OK!",
      });
    } else {
      swal({
        title: "Fail!",
        text: txt,
        icon: "error",
        button: "OK!",
      });
    }
  }

  return (

    <div style={{ 'width': '100%', 'height': '100vh' }}>
      <Hdr />
      <TopBanner name={'Users Master'} />

      <div className="row p16" style={{ 'height': '95%' }}>
        <div className=" c12-l-12 cont__content-parent p4" style={{ 'height': '100%' }}>
          {/* CTA SECTION */}
          <div className="row mb16">
            <div className="c12-l-3">
            </div>
            <div className="c12-l-7"></div>
            <div className="c12-l-2 align-bottom-right">
              <button onClick={openUser} type="button" name="button"
                className="btn large gradient round">Create New User</button>
            </div>
          </div>

          {/* DATA TABLE SECTION */}
          <div className="c12-l-12 cont__content p4" style={{ 'height': '85%' }}>
            <table style={{ 'display': 'block' }}>
              <thead className='thead-blue'>
                <tr>
                  {/* <th className="th-border" width="5%">Id</th> */}
                  <th className="th-border left" width="10%">Login ID</th>
                  <th className="th-border left" width="30%">Name</th>
                  <th className="th-border left" width="10%">Phone Number</th>
                  <th className="th-border left" width="30%">Email</th>
                  <th className="th-border left" width="30%">Department</th>
                  <th className="th-border left" width="30%">User Role</th>
                  <th className="th-border" width="10%">Edit</th>
                  <th className="th-border" width="10%">Change Role</th>
                  <th className="th-border" width="10%">Reset Password</th>
                  <th className="th-border" width="10%">Delete</th>
                </tr>
              </thead>
              <tbody >
                {
                  (dataStat === true ?
                    (
                      data.map((item, index) =>
                        <tr className="tr-two-color-grey" key={index}>
                          {/* <td className="center">{item.id}</td> */}
                          <td className="">{item.login_id}</td>
                          <td className="">{item.name}</td>
                          <td className="">{item.mobile}</td>
                          <td className="">{item.email}</td>
                          <td className="">{item.dept_name}</td>
                          <td className="">{item.role}</td>
                          {
                            (adm === true ?
                              <td onClick={() => { updateOperation(item.id) }} className="center"><img src={require('../asset/icons/adm_edit.png')} alt="" /></td>
                              :
                              <td></td>)
                          }
                          {
                            (adm === true ?
                              <td onClick={() => { changeRole(item.id) }} className="center"><img src={require('../asset/icons/adm_role.png')} alt="" /></td>
                              :
                              <td></td>)
                          }
                          {
                            (adm === true ?
                              <td onClick={() => { resetPasswordOperation(item.id) }} className="center"><img src={require('../asset/icons/adm_unlock.png')} alt="" /></td>
                              :
                              <td></td>)
                          }
                          {
                            (adm === true ?
                              <td onClick={() => { deleteOperation(item.id) }} className="center"><img src={require('../asset/icons/adm_del.png')} alt="" /></td>
                              :
                              <td></td>)
                          }

                        </tr>
                      ))
                    : <tr><td>No data</td></tr>)
                }
              </tbody>
            </table>
          </div>

        {/* SCREEN FOR ADDING NEW USER */}

          <AnimatePresence> {/* Wrap with AnimatePresence */}
            {displayUser && (
            <motion.div 
              key="sliding-container" // Crucial for AnimatePresence to work
              variants={containerVariants}
              initial="hidden"
              animate="visible"
              exit="exit" // Specify the exit animation
              transition={transitionSettings}
              id="newdept" 
              className="cont__lineitem">
              
              <form className="" action="" method="">
                <div className="row box gradient corner-round-t">
                  <div className="c12-l-11">
                    <h3 className='txt-subtlewhite'>Add User</h3>
                  </div>
                  <div className="c12-l-1 align-right">
                    <p onClick={closeUser}><img src={require('../asset/icons/adm_close.png')} alt="" width="24px" height="24px" /></p>
                  </div>
                </div>

                <div className="row mt16 px16">
                  <div className="c12-l-12">

                    <div className="row">
                      <div className="c12-l-3 mt8">
                        <p>User</p>
                      </div>
                      <div className="c12-l-9">              
                        <input type="text" value={selectedUID} className="box small" maxlength="10"
                          placeholder="User ID" onChange={uidHandler} />
                      </div>
                    </div>
                    
                    <div className="row">
                      <div className="c12-l-3 mt8">
                        <p>Name</p>
                      </div>
                      <div className="c12-l-9">  
                        <input type="text" value={selectedName} className="box small"
                          placeholder="Name of the user" onChange={nameHandler} />
                      </div>
                    </div>

                    <div className="row">
                      <div className="c12-l-3 mt8">
                        <p>Phone</p>
                      </div>
                      <div className="c12-l-9">  
                        <input type="text" value={selectedPhone} className="box small"
                          placeholder="Phone Number" onChange={phoneHandler} />
                      </div>
                    </div>

                    <div className="row">
                      <div className="c12-l-3 mt8">
                        <p>Email</p>
                      </div>
                      <div className="c12-l-9"> 
                      <input type="text" className="box small"
                        placeholder="email" value={selectedEmail} onChange={emailHandler} />
                        <p style={{ 'color': 'red', 'fontSize': '0.65rem' }}>{uidErr}</p>
                      </div>
                    </div>

                    <div className="row">
                      <div className="c12-l-3 mt8">
                        <p>Password</p>
                      </div>
                      <div className="c12-l-9"> 
                        <input type="password" value={selectedPassword} className="box small"
                          placeholder="Password" onChange={passwordHandler} />
                          <p style={{ 'color': 'red', 'fontSize': '0.65rem' }}>{pwdErr}</p>
                      </div>
                    </div>

                    <div className="row">
                      <div className="c12-l-3 mt8">
                      
                      </div>
                      <div className="c12-l-9"> 
                      <input type="text" value={selectedConfPassword} className="box small"
                        placeholder="confirm password" onChange={passwordConfHandler} />
                      </div>
                    </div> <br />
    
                    <p style={{ 'fontSize': '0.75rem' }}>Select Department</p>
                      <select className="custom-select" value={selectedDept} onChange={deptHandler} style={{ "width": '98%', 'marginTop': '1px' }}>
                        <option value="0" >Select Department</option>
                        {
                          deptdata.map((item, index) =>
                            <option key={item.id} value={item.id}>{item.dept_name}</option>
                          )
                        }
                      </select>

                    <p className='mt4' style={{ 'fontSize': '0.75rem' }}>Select User Role</p>
                    <select className="custom-select" value={selectedRole} onChange={roleHandler} style={{ "width": '98%', 'marginTop': '1px' }}>
                      <option value="0" >Select Role</option>
                      {
                        roledata.map((item, index) =>
                          <option key={item.id} value={item.id}>{item.name}</option>
                        )
                      }
                    </select>

                    <div id="storeDisplay" style={{ 'display': displayStore }} className="">
                      <select className="custom-select" value={selectedStore} onChange={storeHandler} style={{ "width": '98%', 'marginTop': '1px' }}>
                        <option value="0" >Select Store</option>
                        {
                          storedata.map((item, index) =>
                            <option key={item.id} value={item.id}>{item.store_name}</option>
                          )
                        }
                      </select>
                    </div>

                    <button onClick={verifyUser} type="button"
                      className="btn gradient round">Add User</button>
                  </div>
                </div>
              </form>
            </motion.div>
            )}
          </AnimatePresence>

          {/* SCREEN FROM UPDTAE EXISTING USER */}

          <AnimatePresence> {/* Wrap with AnimatePresence */}
            {displayUpdUser && (
            <motion.div 
              key="sliding-container" // Crucial for AnimatePresence to work
              variants={containerVariants}
              initial="hidden"
              animate="visible"
              exit="exit" // Specify the exit animation
              transition={transitionSettings} 
              id="newdept" className="cont__lineitem">
              <form className="" action="" method="">
                <div className="row box gradient corner-round-tr">
                  <div className="c12-l-11">
                    <h3 className='txt-subtlewhite'>Edit User</h3>
                  </div>
                  <div className="c12-l-1 align-right">
                    <p onClick={closeUpdUser}><img src={require('../asset/icons/adm_close.png')} alt="" width="24px" height="24px" /></p>
                  </div>
                </div>

                <div className="row mt32 px16">
                  <div className="c12-l-12">
                    <br /><br />

                    <input type="hidden" value={userId} />

                    <div className="row">
                      <div className="c12-l-3 mt8">
                        <p>Name</p>
                      </div>
                      <div className="c12-l-9"> 
                      <input type="text" className="box small"
                        placeholder="Name of the user" onChange={(e) => setUserUpdName(e.target.value)}
                        value={updUserName} />
                      </div>
                    </div><br />

                    <div className="row">
                      <div className="c12-l-3 mt8">
                        <p>Email</p>
                      </div>
                      <div className="c12-l-9"> 
                      <input type="text" className="box small"
                        placeholder="Email" onChange={(e) => setUpdEmail(e.target.value)}
                      value={updEmail} />
                      </div>
                    </div><br />

                    <div className="row">
                      <div className="c12-l-3 mt8">
                        <p>Phone</p>
                      </div>
                      <div className="c12-l-9"> 
                      <input type="text" className="box small"
                        placeholder="Phone Number" onChange={(e) => setUpdMobile(e.target.value)}
                        value={updMobile} />
                        </div>
                    </div><br />

                    <div id="storeDisplay" style={{ 'display': displayStore }} className="">
                      <select className="custom-select" onChange={(e) => setupdStoreId(e.target.value)} style={{ "width": '98%', 'marginTop': '1px' }}
                        value={updStoreId}>
                        <option value="0" >Select Store</option>
                        {
                          storedata.map((item, index) =>
                            <option key={item.id} value={item.id}>{item.store_name}</option>
                          )
                        }
                      </select>
                    </div>
                    <br />
                    <button onClick={() => { updateUser(userId) }} type="button"
                      className="btn gradient round">Update User</button>
                  </div>
                </div>
              </form>
            </motion.div>
          )}
          </AnimatePresence>

          {/* SCREEN FROM UPDTAE ROLE OF USER */}

          <AnimatePresence> {/* Wrap with AnimatePresence */}
            {displayRole && (
            <motion.div 
              key="sliding-container" // Crucial for AnimatePresence to work
              variants={containerVariants}
              initial="hidden"
              animate="visible"
              exit="exit" // Specify the exit animation
              transition={transitionSettings} 
              id="newdept" className="cont__lineitem">
              <form className="" action="" method="">
                <div className="row box gradient corner-roun">
                  <div className="c12-l-11">
                    <h3 className='txt-subtlewhite'>change Role</h3>
                  </div>
                  <div className="c12-l-1 align-right">
                    <p onClick={closeRoleUser}><img src={require('../asset/icons/adm_close.png')} alt="" width="24px" height="24px" /></p>
                  </div>
                </div>

                <div className="row mt32 px16">
                  <div className="c12-l-12">
                    <br /><br />

                    <input type="hidden" value={userId} />

                    <p style={{ 'fontSize': '0.75rem' }}>Name</p>
                    <input type="text" className="box small"
                      placeholder="Name of the user" value={updUserName} />

                    <p style={{ 'fontSize': '0.75rem' }}>user role</p>
                    <select className="custom-select" onChange={(e) => setUpdRoleId(e.target.value)} style={{ "width": '98%', 'marginTop': '1px' }}
                      value={updRoleId}>
                      <option value="0" >Select Role</option>
                      {
                        (roleStatus === true ?
                          (
                            roledata.map((item, index) =>
                              <option key={item.id} value={item.id}>{item.name}</option>
                            )
                          )
                          :
                          <option>No Data </option>
                        )
                      }
                    </select>
                    <br />

                    <button onClick={() => { updateRole(userId) }} type="button"
                      className="btn gradient round">Update Role</button>
                  </div>
                </div>
              </form>
            </motion.div>
          )}
          </AnimatePresence>

        </div>
      </div>


    </div>
  );
}

export default Users;
